import { render, staticRenderFns } from "./referralfee.vue?vue&type=template&id=3891d1da&"
import script from "./referralfee.vue?vue&type=script&lang=js&"
export * from "./referralfee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports